import * as Yup from 'yup';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import type { CostForm_VariableCost } from '../fragments/variable-cost.fragment';
import type { CostForm_FixedCost } from '../fragments/fixed-cost.fragment';

export const useCostSchema = () => {
  const { costTypesCodeMap } = useReferencesContext();

  const CostSchema = Yup.object()
    .shape({
      typeId: Yup.string().required('Type de Coût requis'),
      codingConfig: Yup.object()
        .shape({
          code: Yup.string().required('Code requis'),
        })
        .required('Code requis'),
      label: Yup.string().required('Libellé requis'),
      costMarginId: Yup.string().required('Marge sur Coût requise'),
    })
    .test('test-value', 'Valeur du Coût requise', function (value) {
      switch (value.typeId) {
        case costTypesCodeMap.VariableCost._id: {
          const castedValue = value as CostForm_VariableCost;
          return !!castedValue.value;
        }
        case costTypesCodeMap.FixedCost._id: {
          const castedValue = value as CostForm_FixedCost;
          return !!(castedValue.amount.value && castedValue.amount.currencyId);
        }
        default: {
          return false;
        }
      }
    });

  return CostSchema;
};
